import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaCheckCircle } from "react-icons/fa";
import { useGoal } from "./GoalContext";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70vh;
`;

const TopStyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 5vh;
`;

const StyledButton = styled(Button)`
  width: 250px;
  height: 40px;
  font-size: 20px;
`;

const StyledLink = styled(Link)`
  color: white;
  &:hover {
    color: white;
    text-decoration: none;
  }
`;

const StyledCheckMark = styled(FaCheckCircle)`
  color: green;
  font-size: 70px;
`;

const RegisterComplete = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { eventDetails } = location.state || {};

  React.useEffect(() => {
    if (!eventDetails) {
      navigate("/MyPage", {
        replace: true,
        state: { message: "更新結果が見つからなかったので、マイページへ戻りました" },
      });
    }
  }, [eventDetails, navigate]);

  if (!eventDetails) {
    return null;
  }

  return (
    <StyledContainer>
      <h2>無謀な夢の内容を変更しました！</h2>
      <br />
      <StyledCheckMark />
      <h4>
        <br />
        引き続き、無謀な夢への挑戦をお楽しみください。
      </h4>
      <TopStyledContainer></TopStyledContainer>
      <StyledLink to={`/boards/${eventDetails["無謀な夢のID"]}`}>
        <StyledButton variant="primary" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent" }}>
          投稿した夢をみる
        </StyledButton>
      </StyledLink>
      <br />
      <StyledLink to="/">
        <StyledButton variant="primary" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent" }}>
          トップページに戻る
        </StyledButton>
      </StyledLink>
    </StyledContainer>
  );
};

export default RegisterComplete;
